import { render } from "./admin-support-table.vue?vue&type=template&id=20b4d2a6"
import script from "./admin-support-table.vue?vue&type=script&lang=js"
export * from "./admin-support-table.vue?vue&type=script&lang=js"

import "./admin-support-table.vue?vue&type=style&index=0&id=20b4d2a6&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__